// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3756":"2f630642","4973":"dd9a06fc"}[chunkId] + ".chunk.css";
};